import React from "react";
import { Navigate, Outlet } from "react-router-dom";


export default function PrivateRoutes() {
    let userId = localStorage.getItem("token") == null ? false : true;
    return (
        <div>
            {userId ? <Outlet /> : <Navigate to="/" />};
        </div>

    )
}